import { Injectable } from '@angular/core';
import { CategoryApiService, MarketplaceCategory, GetCategoriesResponse } from '@galaxy/marketplace-apps';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class CategoryService {
  public categories$: Observable<MarketplaceCategory[]>;
  public categoryMap$: Observable<Map<string, string>>;

  constructor(private categoryApiService: CategoryApiService) {
    this.categories$ = this.categoryApiService.getCategories({}).pipe(
      take(1),
      map((categoryResponse: GetCategoriesResponse) => categoryResponse.category),
    );
    this.categoryMap$ = this.categories$.pipe(
      take(1),
      map((categories) => {
        const categoryMap = new Map<string, string>();
        for (let i = 0; i < categories.length; i++) {
          categoryMap.set(categories[i].id, categories[i].name);
          for (let j = 0; j < categories[i].subCategories.length; j++) {
            categoryMap.set(categories[i].subCategories[j].id, categories[i].subCategories[j].name);
          }
        }
        return categoryMap;
      }),
    );
  }
}
